var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.98 134.39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M143.77 134.21l-108.46.18A35.39 35.39 0 010 98.92v-.34l.42-62.46A36.12 36.12 0 0136.21.19L144.66 0A35.39 35.39 0 01180 35.47v.34l-.41 62.46a36.12 36.12 0 01-35.82 35.94zM36.18 4.23A32 32 0 004.42 36.12L4 98.57a31.42 31.42 0 0031 31.79h.3l108.45-.19a32.06 32.06 0 0031.77-31.89l.48-62.46A31.41 31.41 0 00144.93 4h-.3z",
    fill: "#1253fa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M68.86 101.49V33.35L122 68zm5-58.91v49.85l38.87-24.52z",
    fill: "#084cfa"
  })))));
}

export default SvgYoutube;